import { render, staticRenderFns } from "./NoDataInfo.vue?vue&type=template&id=47d2ff62&"
import script from "./NoDataInfo.vue?vue&type=script&lang=js&"
export * from "./NoDataInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports